export const ANONYMOUS_ID_KEY = 'gb_user_anonymous_id'
export const ANONYMOUS_ID_COOKIE = 'gb_anonymous_id'
export const COOKIE_EXPIRY_DAYS = 365
